import React, { Component } from "react";
import Global from "../../Global";
import "./PopUpAlertMessageBox.css";

export default class PopUpAlertMessageBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: false,
      message: null,
    };

    this.handleDismiss = this.handleDismiss.bind(this);
  }
  componentWillMount() {
    // FETCH JSON
    var url = Global.getAPI("top-navigation");
    var self = this;
    fetch(url)
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Error API: topnav");
        }
        return response.json();
      })
      .then(function(data) {
        self.setState({
          message: data.general.alertPopUpMessage,
          isVisible: data.general.popUpMessage,
        });
      });
  }

  handleDismiss() {
    this.setState({ isVisible: false });
  }

  render() {
    const isVisible = this.state.isVisible;
    const message = this.state.message || "";

    if(!isVisible || message.length <= 0) return null;

    return (
      <div className="popUpContainer">
        <button className="btnDismiss" onClick={this.handleDismiss}>
          &#10006;
        </button>
        <div className="messageContainer">
          <p className="messageText" data-nosnippet="true" dangerouslySetInnerHTML={{__html: message}}></p>
        </div>
      </div>
    );
  }
}
